<template>
  <div>
    <div class="card w-100">
      <div class="card-body">
        <h5 class="card-title mb-4">Calculadora de Win Rate</h5>
        <div class="row">
          <div class="col-12 col-md-6 mt-3">
            <div class="button-gradient-yellow">
              <label>Apostas ganhas</label>
            </div>
            <input type="text" v-model="betsWin" v-on:keyup="verifyBetsWin(betsWin)" class="form-control input-format-grey" placeholder="$100,00">
          </div>
          <div class="col-12 col-md-6 mt-3">
            <div class="button-gradient-yellow">
              <label>Quantidade de apostas</label>
            </div>
            <input type="text" v-model="totalBets" v-on:keyup="verifyTotalBets(totalBets)" class="form-control input-format-grey" placeholder="@1.90" style="padding-left: 250px;">
          </div>
          <div class="col-12 col-md-6 mt-3">
            <div class="button-gradient-green">
              <label class="text-white">Taxa de vitória</label>
            </div>
            <money v-model="totalWinPercent" class="form-control input-format-green" v-bind="percent" />
          </div>
          <div class="col-12 mt-3">
            <div class="clubedaaposta">
              <label>clubedaposta.com</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Money } from 'v-money';

export default {
  name: 'WinRateCalculator',
  components: {
    Money
  },
  data () {
    return {
      betsWin: 90,
      totalBets: 150,
      totalWinPercent: 60,
      percent: {
        decimal: '.',
        prefix: '',
        suffix: ' %',
        precision: 2,
        masked: false
      },
    }
  },
  methods: {
    verifyBetsWin(item) {
      this.betsWin = item;
      this.totalWinPercent = ((this.betsWin/this.totalBets)*100)
    },
    verifyTotalBets(item) {
      this.totalBets = item;
      this.totalWinPercent = ((this.betsWin/this.totalBets)*100)
    },
  }
}
</script>

<style scoped>
.input-format-grey {
  padding-left: 200px;
}
.input-format-green {
  padding-left: 190px;
}
</style>
